import ProjectMatchedOrganizationsWizardStepReducer from './ProjectMatchedOrganizationsWizardStepReducer';

export default from './ProjectMatchedOrganizationsWizardStepContainer';
export const ProjectMatchedOrganizationsWizardStepReducers = {
  ProjectMatchedOrganizationsWizardStepReducer,
};
